import styled, { css } from 'styled-components';
import { colors, ApMenu } from '@alixpartners/ui-components';

export const StyledMenu = styled(ApMenu)`
	padding-bottom: 0 !important;
	max-width: 520px !important;
	max-height: 240px !important;
	padding: 0 !important;
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	max-height: 100%;
	width: 520px;
`;

export const ListItem = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	min-height: 40px;
	padding: 0 24px 0 32px;
	cursor: default;

	&.active,
	&:focus,
	&:hover {
		background-color: ${colors.lightGreen1};
	}
`;

export const ListTitle = styled.div`
	color: ${colors.grey6};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	padding-right: 32px;

	span {
		color: ${colors.grey8};
		font-weight: 500;
	}
`;

export const ListInfo = styled.div`
	color: ${colors.grey5};
	margin-left: auto;
	font-size: 13px;
	letter-spacing: 0.3px;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
`;

export const List = styled.div`
	padding: 8px 0;
	overflow: auto;
`;

export const InputWrapper = styled.div`
	position: relative;

	svg {
		z-index: 2;
	}

	${({ showIcon }) =>
		showIcon &&
		css`
			input {
				padding-left: 26px;
			}

			svg {
				margin-left: 8px;
				position: absolute;

				&:last-child {
					position: absolute;
					top: 0;
					right: 0;
					margin-right: 8px;
					cursor: pointer;
					z-index: 1;
				}
			}
		`};
`;
